/**
 * 将funcs放到下一个exec stack中执行
 */
let funcs: (() => void)[] = [];

let flag = false;

// TODO 加锁
function flush() {
    if (!funcs.length) return;

    // TODO
    setTimeout(() => {
        funcs.forEach(func => func());
        funcs = [];
        flag = false;
    }, 0);
}

export default function nextTick(func: () => void) {
    funcs.push(func);

    if (!flag) {
        flag = true;
        flush();
    }
}
